
import { OptionMenu } from "../prm/option-menu";
import { Name } from "../prm/name";
import { occupation } from "./schwab_constants.json";

class OccupationMenu extends OptionMenu {

  constructor(name) {
    super(name, [], true);
    occupation.forEach(item => {
      this.menu.push(new Name(item.id, item.label));
    })
  }
}

export { OccupationMenu };
